import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form';
import { useNavigate, Link } from "react-router-dom";
import { loadStripe } from '@stripe/stripe-js';
import postApi from '../../services/helpers/axios/apiCalls';
import { validateEmail } from '../../services/helpers/helpers';
import InputOTP from '@onefifteen-z/react-input-otp';
import './otpStyles.css'
import { BsCheckCircleFill } from "react-icons/bs"
import { footerAssets, generalAssets, signupPageAssets } from '../../assets/media';
import countriesList from '../../components/pages_components/contact/countriesList';
const { eugdprLight, iso } = footerAssets
const { logoYellow } = generalAssets.brandLogo
const { otpMobile ,optsvg} = signupPageAssets




const Signup = ({ tier }) => {

    var navigate = useNavigate()

    const planComesWith = {
        "free": [
            "25 Internal Candidate Assessments",
            "1 Assessment Game",
            "Access To Test Library",
            "Pre-selected Fields for Data Collection",

        ],
        "standard": [
            "300 Candidate Assessments",
            "1 Assessment Game",
            "Access to Test library",
            "Pre-selected Fields for Data Collection",
            "Customizable Data Fields (limited)",
            "Candidate Feedback Survey"

        ],
        "premium": [
            "1200 Candidate Assessments",
            "2 Assessment Games",
            "Access to Test library",
            "Pre-selected Fields for Data Collection",
            "Customizable Data Fields",
            "Candidate Feedback Survey"
        ],
    }

    const { register, getValues, handleSubmit, formState: { errors } } = useForm()

    const [isSubmitted, setisSubmitted] = useState(false)
    const [isOTPTriggered, setisOTPTriggered] = useState(false)
    const [sid, setsid] = useState()



    const handleFormSubmit = async () => {
        console.log(getValues('country').toLowerCase())
        if (!sid) {

            setisOTPTriggered(true)

            // API OBJECT
            let otpSendRequestObj = {
                url: "auth/email/send-otp",
                data: {

                    email: getValues('workEmail').toLowerCase()
                },
                config: {
                }
            }

            // API CALL
            postApi(otpSendRequestObj)
                .then(res => {

                    const data = res.data
                    const ressid = data.verification.sid
                    console.log("sid", sid)
                    setisSubmitted(true)
                    setisOTPTriggered(false)
                    const candidateEmail = getValues('workEmail')
                    localStorage.setItem('candidateEmail', JSON.stringify(candidateEmail))
                    setsid(ressid)


                })
                .catch((e) => console.log(e))

        }

    }

    const [otpError, setotpError] = useState({ error: false, errorMessage: "" })
    const [otpValue, setotpValue] = useState()
    const [disabledOTPInput, setdisabledOTPInput] = useState(false)
    const [isEmailExists, setisEmailExists] = useState({isExists:true,msg:''})

    const handleOTPChange = async (otp) => {
        setotpValue(otp)
        if (otp.length === 6) {
            setdisabledOTPInput(true)

            const stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

            const otpVerificationRequestObj = {
                url: "/auth/email/verify-otp",
                data: {

                    otp,
                    token: sid
                },
                config: {
                }
            }
            postApi(otpVerificationRequestObj).then(res => {
                const data = res.data
                console.log("data", data)
                if (data.isVerified === false) {
                    setotpError({ error: true, errorMessage: "WRONG OTP ENTERED" })
                    setdisabledOTPInput(false)
                    setotpValue('')

                } else {

                    setotpError({ error: false, errorMessage: "" })
                    setdisabledOTPInput(true)
                    console.log('job title', getValues('jobTitle'))
                    // API
                    let apiCallRequest = {
                        url: "/auth/pay/create-checkout-session",
                        data: {
                            name: getValues('fullName'),
                            phone: "",
                            type: tier,
                            email: getValues('workEmail').toLowerCase(),
                            jobtitle: getValues('jobTitle'),
                            company: getValues('companyName'),
                            country: getValues('country').toLowerCase()
                        },
                        config: {
                        }
                    }

                    postApi(apiCallRequest).then(res => {

                        const data = res.data
                        console.log("res", data)
                        const sessionId = data?.session?.id
                        localStorage.setItem('sessionId', JSON.stringify(sessionId))
                        if (tier !== "free") {

                            stripe.redirectToCheckout({ sessionId })
                        } else {
                            if(res.data.status == true) {
                                navigate('/success/free')
                            }else{
                                setisEmailExists(
                                    {                                    
                                    isExists:res.data.status,
                                    msg:res.data.msg
                                })
                                setTimeout(() => {
                                    navigate('/')  
                                },2000)
                            }

                        }

                    }).catch((e) => console.log(e))
                }



            }).catch(er => {
                console.log('eeee', er.message)
            })

        }
    }

    useEffect(() => {

        console.log(otpValue)

    }, [otpValue])



    return (
        <div className="signupPage">
            <div className="signupPageWrapper flex flex-col  lg:flex lg:flex-row lg:min-h-screen">
                {/* left side */}
                <div className="left lg:w-[50%] bg-[#333333] lg:flex lg:flex-col lg:justify-between lg:items-center p-10 lg:p-0">
                    <div className="empty"></div>
                    <div className="leftMainContent  text-[#ffd700] w-fit mx-auto mt-[5rem] flex flex-col items-center lg:items-start 2xl:items-start  ">
                        <h1 className='text-[3rem] font-bold 2xl:text-[4rem] 2xl:items-center '>{tier.toUpperCase()} PLAN</h1>
                        <h4 className='text-[1.5rem] font-semibold 2xl:text-[40px]'>Your Plan Comes With:</h4>
                        <div className="bulleticks mt-5 text-md">
                            {
                                planComesWith[tier].map((desc, index) =>
                                    <div key={desc + index} className="bulletTick flex items-center mt-2">
                                        <BsCheckCircleFill className='2xl:text-[26px] 2xl:mr-2' />
                                        <p className='ml-2 2xl:text-[22px]'>{desc}</p>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <footer className="w-full mt-10">
                        <div className="footerWrapper h-full flex justify-center items-end">
                            <div className="footerContent flex justify-around w-[20rem] p-5">

                                <img src={eugdprLight} className="object-contain w-[10rem]" alt="" />
                                <img src={iso} className="object-contain w-[4rem]" alt="" />
                            </div>
                        </div>
                    </footer>
                </div>

                {/* right side Signup Form */}
                {
                    isSubmitted === false ?
                        <div className="right-form  lg:w-[50%] bg-[white] flex justify-center items-center">
                            <div className="rightMainContent">
                                <div className="form lg:w-[30rem] 2xl:w-[36rem] sm:w-[40rem] mx-auto lg:flex lg:flex-col lg:items-center lg:justify-center p-5 lg:py-1 px-[4rem] md:px-8 lg:mt-2 ">
                                    <div className="logo flex justify-center mb-10 xl:mb-3 lg:mb-5">
                                        <Link to={'/'}>
                                            <img src={logoYellow} alt="logo" className='h-[4rem] object-contain xl:h-[5rem] 2xl:h-[6rem]' />
                                        </Link>
                                    </div>
                                    <h2 className='text-[1.8rem] text-center font-bold mt-3 2xl:text-[28px] lg:mt-0 xl:text-[20px]'>
                                            Start Your Free Trial
                                    </h2>
                                    <p className='text-[#007e8c] text-center text-[15px] mt-1 mb-3 tracking-wider font-semibold'>(No Credit Card Required)</p>

                                    <form onSubmit={handleSubmit(handleFormSubmit)} className='w-full mt-10 lg:mt-5 xl:mt-3 2xl:mt-4 text-[#7E7E7E] pb-5'>
                                        {/* Email */}
                                        <div className="field w-full">
                                            <div className="label">
                                                <label htmlFor="workEmail" className='text-black font-bold md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Work Email *</label>
                                            </div>
                                            <div className="input mt-2 lg:mt-1 xl:mt-0">
                                                <input
                                                    {...register("workEmail", {
                                                        required: {
                                                            value: true, message: "Field cannot be empty"
                                                        },
                                                        pattern: {
                                                            value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                            message: 'Please enter a valid email',
                                                        },
                                                        validate: { validateEmail }
                                                    })}
                                                    className={`${errors.workEmail && 'border border-red-500  outline-none 2xl:h-[50px]'} 2xl:w-[507px] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] border border-gray-200 bg-[#F9F9F9] rounded h-[2.2rem] px-5 py-6 md:p-2 w-full outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] '`}
                                                    type="email"
                                                    name="workEmail"
                                                    id="workEmail"
                                                    placeholder='Eg: example@xyzconsultants.com'
                                                />
                                                <p className='text-red-500 text-xs mt-1'>{errors.workEmail && errors.workEmail.message}</p>
                                                {/* <p className='text-red-500'>{validateEmail(getValues('workEmail')) && "try with work email"}</p> */}

                                            </div>
                                        </div>
                                        {/* Name */}
                                        <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
                                            <div className="label">
                                                <label htmlFor="fullName" className='text-black font-bold md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Full Name *</label>
                                            </div>
                                            <div className="input mt-2 xl:mt-0">
                                                <input
                                                    {...register("fullName", { required: true })}
                                                    className={`${errors.fullName && 'border border-red-500'} 2xl:h-[50px]'} 2xl:w-[507px] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] rounded h-[2.2rem] px-5 py-6 md:p-2 w-full outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `}
                                                    type="text"
                                                    name="fullName"
                                                    id="fullName"
                                                    placeholder='Eg: John Doe' />
                                                <p className='text-red-500 text-xs mt-1'>{errors.fullName && 'Field cannot be empty'}</p>

                                            </div>
                                        </div>
                                        {/* Company Name */}
                                        <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
                                            <div className="label">
                                                <label htmlFor="companyName" className='text-black font-bold md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Company Name *</label>
                                            </div>
                                            <div className="input mt-2 xl:mt-0">
                                                <input   {...register("companyName", { required: true })} className={` ${errors.companyName && 'border border-red-500'} 2xl:h-[50px]'} 2xl:w-[507px] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] rounded h-[2.2rem] px-5 py-6 md:p-2 w-full outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `} type="text" name="companyName" id="companyName" placeholder='Eg: XYZ Consultants' />
                                                <p className='text-red-500 text-xs mt-1'>{errors.companyName && 'Field cannot be empty'}</p>

                                            </div>
                                        </div>

                                        {/* Job Title */}
                                        <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
                                            <div className="label">
                                                <label htmlFor="companyName" className='text-black font-bold md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Job Title *</label>
                                            </div>
                                            <div className="input mt-2 xl:mt-0">
                                                <input   {...register("jobTitle", { required: true })} className={` ${errors.jobTitle && 'border border-red-500'} 2xl:h-[50px]'} 2xl:w-[507px] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] rounded h-[2.2rem] px-5 py-6 md:p-2 w-full outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `} type="text" name="jobTitle" id="jobTitle" placeholder='Eg: HR Manager' />
                                                <p className='text-red-500 text-xs mt-1'>{errors.jobTitle && 'Field cannot be empty'}</p>

                                            </div>
                                        </div>

                                        {/* Country */}
                                        <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
                                            <div className="label">
                                                <label htmlFor="country" className='text-black font-bold md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Country *</label>
                                            </div>
                                            <div className="input mt-2 xl:mt-0">
                                                <select  {...register("country", { required: true })} className={` ${errors.country && 'border border-red-500'} 2xl:h-[50px]'} 2xl:w-[507px] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] rounded h-[3.2rem] lg:h-[2.2rem] px-5 lg:py-2 md:p-2 w-full outline-none lg:text-[14px] xl:text-[13px] 2xl:py-2 xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `} type="text" name="country" id="country">
                                                    <option value="">Select Country</option>
                                                    {
                                                        countriesList.map((country, index) =>
                                                            <option value={country.label}>{country.label}</option>
                                                        )
                                                    }

                                                </select>

                                                <p className='text-red-500 text-xs mt-1'>{errors.country && 'Field cannot be empty'}</p>

                                            </div>
                                        </div>


                                        <div className="field w-full mt-5 lg:mt-3">


                                            <div className="checkBox flex items-center mt-5 lg:mt-2 text-[#ffd700]">
                                                <input value="yes" {...register("isAgree", { required: true })} className='h-4 w-4 mr-2 flex-shrink-0' type="checkbox" />
                                                <p className='xl:text-[13px] 2xl:text-[14px] text-[#5A5A5A]'>I agree to the TTG <span className='font-semibold underline'><a href="https://thetalentgames.com/terms-of-use/">Terms of Services</a></span> & <span className='font-semibold underline'><a href="https://thetalentgames.com/privacy-policy/">Privacy Policy</a></span></p>
                                            </div>
                                            <p className='text-red-500 text-xs mt-1'>{errors.isAgree && 'To proceed, you must click the agreement check box above'}</p>

                                            <div className="proceed mt-5">
                                                <button disabled={isSubmitted} type='submit' className='bg-[#ffd700] h-[2.8rem] p-3 md:h-[2.5rem] md:p-2 w-full mt-5 rounded text-md text-[#5A5A5A] xl:h-[2.1rem] xl:text-sm xl:mt-2 2xl:h-[2.5rem] 2xl:p-3'>
                                                    <div className="container flex items-center justify-center">
                                                        {

                                                            isOTPTriggered &&
                                                            <div className="icon"> <i className="fa fa-circle-o-notch fa-spin mr-2" style={{ fontSize: "16px" }}></i></div>
                                                        }
                                                        <div className="text font-bold md:font-semibold">
                                                            {
                                                                isSubmitted ? 'PLEASE WAIT' : 'Send One-Time-Password'
                                                            }
                                                        </div>
                                                    </div>

                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="right-otp  lg:w-[50%] bg-[white] flex justify-center items-center my-10">
                            <div className="rightMainContent">
                                <div className="form lg:w-[30rem] 2xl:w-[36rem] sm:w-[40rem] mx-auto lg:flex lg:flex-col lg:items-center lg:justify-center p-5 lg:py-1 px-8 lg:mt-2 ">
                                    <div className="logo flex justify-center mb-10 xl:mb-3 lg:mb-5">
                                        {/* ttg logo */}
                                        <img src={logoYellow} alt="logo" className='h-[3.5rem] object-contain md:h-[6rem] lg:h-[6rem] xl:h-[4rem] 2xl:h-[10rem]' />
                                    </div>

                                    <h2 className='text-[1.5rem] md:text-[1.8rem] text-center font-semibold mt-2 lg:text-[24px] 2xl:text-[32px] lg:mt-0 xl:text-[18px]'>Please Enter OTP</h2>

                                    {/* otp box */}
                                    <div className="otpBox mt-[2rem] md:mt-[25px] flex flex-col justify-center items-center">
                                        {/* otp avatar */}
                                        {/* <img src={window.innerWidth < 768 ? otpMobile : otpDesktop} alt="otp avatar" className='block object-contain w-[40%] md:w-[50%]' /> */}
                                        <img src={window.innerWidth < 768 ? otpMobile : optsvg } alt="otp avatar" className='block object-contain w-[40%] md:w-[50%]' />


                                        <p className='text-[#434141] text-center mt-[34px] mb-[53px] md:text-[16px] md:leading-[28px] lg:text-[16px] lg:leading-[28px] xl:text-[16px] xl:leading-[30px] 2xl:text-[21px] 2xl:leading-[32px] font-[500]'>Your OTP (one-time-password) has been generated and sent to your email address.</p>

                                        <InputOTP onChange={handleOTPChange} value={otpValue} numberOnly={true} disabled={disabledOTPInput} error={otpError.error} errorMessage={otpError.errorMessage} autoFocus={true} />

                                        {/* loader */}

                                        {
                                            disabledOTPInput && isEmailExists.isExists===true &&
                                            <div className="loader mt-10">
                                                <p>Please wait ..</p>
                                            </div>
                                        }
                                        {
                                            isEmailExists.isExists == false &&
                                            <div className="loader mt-10">
                                                <p>{isEmailExists.msg}</p>
                                            </div>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                }

            </div>
        </div>
    )
}

export default Signup